// import { getLocale } from '../utils/utils';

export const api_key = '0031c695-0c2f-4bd4-a036-5c6217b861ff';
export const token = '8ca266456dc74ead896fb9b0bc017e7b';
export const lang = 'cn';
export const baseURL = 'https://poweris.inhand.online';
export const locale = 'cn';
